import React, { Component, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import codeimage from "../img/Group 527.png";
import Featurescards from "../Components/Featurescards";
import Web3 from "web3";
import "./earn.css";
import "./earn.css";

var accounts = [];
var contract;
var web3;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));
const Discussionbody = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(1);
  const [balance, setBalance] = useState(0);
  const [display, setDisplay] = useState(false);
  const [rewards, getRewards] = useState(0);
  useEffect(() => {
    const address = "0xb756d2a9db6d8bd21a4b77f69941d647b5135a50";
    const abi = [
      { inputs: [], stateMutability: "nonpayable", type: "constructor" },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            indexed: true,
            internalType: "address",
            name: "spender",
            type: "address",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
        ],
        name: "Approval",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: false,
            internalType: "uint256",
            name: "minTokensBeforeSwap",
            type: "uint256",
          },
        ],
        name: "MinTokensBeforeSwapUpdated",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "address",
            name: "previousOwner",
            type: "address",
          },
          {
            indexed: true,
            internalType: "address",
            name: "newOwner",
            type: "address",
          },
        ],
        name: "OwnershipTransferred",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: false,
            internalType: "uint256",
            name: "tokensSwapped",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "ethReceived",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "tokensIntoLiqudity",
            type: "uint256",
          },
        ],
        name: "SwapAndLiquify",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: false,
            internalType: "bool",
            name: "enabled",
            type: "bool",
          },
        ],
        name: "SwapAndLiquifyEnabledUpdated",
        type: "event",
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: "address",
            name: "from",
            type: "address",
          },
          {
            indexed: true,
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
        ],
        name: "Transfer",
        type: "event",
      },
      {
        inputs: [],
        name: "_liquidityFee",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "_maxTxAmount",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "_taxFee",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "owner", type: "address" },
          { internalType: "address", name: "spender", type: "address" },
        ],
        name: "allowance",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "spender", type: "address" },
          { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "approve",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "balanceOf",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "changeLimit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [],
        name: "decimals",
        outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "spender", type: "address" },
          { internalType: "uint256", name: "subtractedValue", type: "uint256" },
        ],
        name: "decreaseAllowance",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "tAmount", type: "uint256" }],
        name: "deliver",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "excludeFromFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "excludeFromReward",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [{ internalType: "address", name: "", type: "address" }],
        name: "exist",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "geUnlockTime",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "getRewards",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "includeInFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "includeInReward",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "spender", type: "address" },
          { internalType: "uint256", name: "addedValue", type: "uint256" },
        ],
        name: "increaseAllowance",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "isExcludedFromFee",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "isExcludedFromReward",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "limit",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "time", type: "uint256" }],
        name: "lock",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [{ internalType: "address", name: "", type: "address" }],
        name: "myRewards",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "name",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "numberOfTokenHolders",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "owner",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint256", name: "tAmount", type: "uint256" },
          { internalType: "bool", name: "deductTransferFee", type: "bool" },
        ],
        name: "reflectionFromToken",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [],
        name: "seeRewards",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint256", name: "liquidityFee", type: "uint256" },
        ],
        name: "setLiquidityFeePercent",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "uint256", name: "maxTxPercent", type: "uint256" },
        ],
        name: "setMaxTxPercent",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [{ internalType: "bool", name: "_enabled", type: "bool" }],
        name: "setSwapAndLiquifyEnabled",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "taxFee", type: "uint256" }],
        name: "setTaxFeePercent",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [],
        name: "swapAndLiquifyEnabled",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "symbol",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "rAmount", type: "uint256" }],
        name: "tokenFromReflection",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        name: "tokenHolder",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "totalFees",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "totalSupply",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "recipient", type: "address" },
          { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "transfer",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "sender", type: "address" },
          { internalType: "address", name: "recipient", type: "address" },
          { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "transferFrom",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [
          { internalType: "address", name: "newOwner", type: "address" },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      {
        inputs: [],
        name: "uniswapV2Pair",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "uniswapV2Router",
        outputs: [
          {
            internalType: "contract IUniswapV2Router02",
            name: "",
            type: "address",
          },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [],
        name: "unlock",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      { stateMutability: "payable", type: "receive" },
    ];
    function abc() {
      if (window.ethereum !== undefined) {
        web3 = new Web3(window.ethereum);

        contract = new web3.eth.Contract(abi, address);
        console.log(contract);
        window.ethereum
          .request({ method: "eth_requestAccounts" })
          .then((_accounts) => {
            console.log(_accounts);
            accounts = _accounts;
            function fetchBalance() {
              contract.methods
                .balanceOf(accounts[0])
                .call()
                .then((_balance) => {
                  setBalance((_balance / 1e18).toFixed(18));
                  console.log(balance);
                });
            }
            function fetchRewards() {
              contract.methods
                .myRewards(accounts[0])
                .call()
                .then((_rewards) => {
                  getRewards((_rewards / 1e18).toFixed(18));
                  console.log(rewards);
                  setDisplay(true);
                });
            }
            setInterval(fetchBalance, 5000);
            setInterval(fetchRewards, 5000);
          });
      } else {
        alert("please install metamask");
      }
    }
    abc();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="pcc---slider">
      <Container>
        <Grid container justify="center">
          <Grid container justify="center" md={8} className="mt-5 py-md-3">
            <h1>Dashboard</h1>
          </Grid>
          {/* <p style={{fontSize:"11px",color:"lightgrey"}}>1% ETH FROM ALL SALES ON UNISWAP ARE REWARDED TO HOLDERS</p> */}
          <Grid container justify="center" md={8}>
            <AppBar position="static" className="px-lg-5 mb-4">
              <Tabs value={value} onChange={handleChange}>
                {/* <Tab style={{display:"none"}} label="TOKENOMICS" {...a11yProps(0)} /> */}
                {/* <Tab label="Connect Wallet to See/Claim Reward" style={{fontSize:"11px"}} {...a11yProps(1)} /> */}
                {/* <Tab label="OUR VISION" {...a11yProps(2)} /> */}
              </Tabs>
            </AppBar>
            {/* <TabPanel value={value} index={0}>
                        <p className="text-left">
                            <h4>FULL TOKENOMICS REPORT</h4>
                            <h6>• Circulation</h6>
                            2000 coins are going to be in circulation with a total of 4500 coins in supply. This will ensure that holding coins provides you with quick returns.<br />
                            <h6>•	Coin Burn</h6>
                            Surplus coins will be burned off to combat inflation and ensure that your coins always end up giving back more than you put in.<br />
                            <h6>•	Staking</h6>
                            The staking event will take place 3 weeks after launch. Once staked your coins cannot be liquidated, this is to help protect yours and everyone else’s investments while ensuring that demand is always higher than supply.<br />
                            <h6>•	Marketing</h6>
                            50 coins from the total supply will be designated to marketing the coin. This will help supplement demand.<br />
                            <h6>•	Initialization</h6>
                            50 coins will be provided to early contributors and airdropped to kickstart the process and incentivize early adopters.
                        </p>
                    </TabPanel> */}
            <TabPanel value={value} index={1}>
              <p className="text-left">
                <div
                  className="pcc---feature-section"
                  style={{
                    width: "427px",
                    marginRight: "auto",
                    marginLeft: "auto",
                  }}
                >
                  <Grid
                    container
                    justify="center"
                    xs={12}
                    spacing={3}
                    className="mx-auto"
                  >
                    <Grid
                      container
                      justify="center"
                      direction="column"
                      xs={12}
                      spacing={3}
                      className="mx-auto"
                    ></Grid>
                    <div
                      className="my-5"
                      style={{
                        borderRadius: "10px",
                        border: "1px solid white",
                        backgroundColor: "#F4F6F8",
                      }}
                    >
                      {/* <input className="" type="text" style={{padding:"20px",borderColor:"white"}} disabled placeholder="253"   /> <a href="" className="mt-5 " style={{backgroundColor:"#ffffff",color:"#4043ff",paddingLeft:"20px",paddingRight:"20px",paddingTop:"15px",paddingBottom:"20px",width:"300px",fontSize:"21px"}}>ETH</a> */}
                      <div className="mt-4 text-center">
                        <div className="mb-3">
                          <span className="mt-5">Balance</span>
                          <span style={{ marginLeft: "49px" }}>Rewards</span>
                        </div>

                        <div className="mb-3">
                          <span>1234567890</span>
                          <span style={{ marginLeft: "49px" }}>1234567890</span>
                        </div>

                        <div className="mb-3">
                          <span>PCAT</span>
                          <span style={{ marginLeft: "49px" }}>ETH</span>
                        </div>

                        <a
                          href=""
                          className="mt-5 ml-2 "
                          style={{
                            backgroundColor: "#4043ff",
                            paddingLeft: "20px",
                            paddingRight: "20px",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            width: "300px",
                            color: "white",
                            fontSize: "17px",
                          }}
                        >
                          Claim Reward
                        </a>
                      </div>
                      <p
                        className="mt-3"
                        style={{ fontSize: "10px", padding: "15px" }}
                      >
                        Warning Note :<br></br>
                        Our rewards might be less then the transaction cost . So
                        <br></br>
                        please be advised to claim or see the difference in
                        couple of
                      </p>
                    </div>
                  </Grid>
                </div>
              </p>
              <Grid
                container
                direction="row"
                justify="center"
                md={11}
                className="mt-4"
              >
                <Grid
                  container
                  direction="row"
                  justify="center"
                  // xs={12}
                  // sm={4}
                  // className="pcc---whitepapercard my-5 p-5"
                >
                  <img
                    src={codeimage}
                    className="img-fluid mb-3"
                    style={{ width: "100%" }}
                  />
                  {/* <p className="text-center mb-5 w-100">Individuals, rewarded for their contributions and hard work</p>
                    <p className="text-center mb-5 w-100">/</p>
                    <p className="text-center mb-5 w-100">Thank your for your donations to help the project grow!</p> */}
                </Grid>
              </Grid>
            </TabPanel>
            {/* <TabPanel value={value} index={2}>
                        <p className="text-left">
                        To become the go-to crypto currency option for people worldwide. Our currency is tailored to appeal to a large target market and to those who would otherwise be hesitant to invest. With a decentralized currency, individual owners have more control over governance and vote for how they want to run things. Initially we will be launching with zero developer fees and zero transfer fees. 50 coins from our ecosystem will be contributed to our marketing budget.
                        </p>
                    </TabPanel> */}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Discussionbody;
